import React from 'react';

export function BrowseGenres() {
  return <div></div>;
}
